import S3FileBrowser from "./S3FileBrowser";
import { listDownloads, getDownloadUrl } from "../../newBackendApi/newDownloads";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import Header from "../../Templates/Header";
export const Downloads = () => {
    const [s3Objects, setS3Objects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                setLoading(true);
                const data = await listDownloads();
                setS3Objects(data);
                setError(null);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchFiles();
    }, []); 

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 400 }}>

<CircularProgress color="secondary" />            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ p: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 400 }}>
                <Typography color="error" variant="h6">
                    Error loading files: {error}
                </Typography>
            </Box>
        );
    }

    return (

        <Box>
            <Header
            title="Downloads"
            subtitle="Protected assets · Shared with your organization"
            />
        <S3FileBrowser
            
            s3Objects={s3Objects}
            rootLabel="Shared with Me"
            onAction={async (action, item) => {
                if (action === 'Download') {
                    try {
                        const url = await getDownloadUrl(item.key);
                        window.location.href = url;
                    } catch (err) {
                        console.error("Download failed:", err.message);
                    }
                }
            }}
            
        />
        </Box>
    );
}